// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*!
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */::ng-deep .grid-row-text-overlay{padding-left:45px}`, "",{"version":3,"sources":["webpack://./packages/builder-job-admin/jobs/components/job-financials-list/job-financials-list.component.scss"],"names":[],"mappings":"AAAA;;;EAAA,CAKE,iCACE,iBAAA","sourcesContent":["/*!\n * Developed for G.J. Gardner Homes by Softeq Development Corporation\n * http://www.softeq.com\n */\n::ng-deep{\n  .grid-row-text-overlay{\n    padding-left:45px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
